import './App.css';
import Box from './components/Box/Box'

function App() {
  return (
    <main className="App">
      <Box/>
    </main>
  );
}

export default App;
